import {
  Group,
  MockHook,
  useAsyncEffect,
} from '@jupiterone/jupiter-web-toolkit';
import { useMemo, useState } from 'react';
import useGroups from 'navbar/src/jupiterAccountSettings/hooks/useGroups';
export interface LazyLoadListProps {
  addText: string;
  titleText: string;
  onSelect: (id: Group['id'], tab: number) => void;
  onAdd: VoidFunction;
}
const useLazyLoadListLogic = ({
  addText,
  titleText,
  onSelect,
  onAdd,
}: LazyLoadListProps) => {
  const {
    groups: items,
    loading,
    hasMore: hasNextPage,
    fetchMoreGroups: loadMore,
    fetchAllGroups: loadAll,
  } = useGroups();
  const [filter, setFilter] = useState<string>('');
  const isLoading = (filter && hasNextPage) || loading;
  const filteredList = useMemo(() => {
    const lowerFilter = filter.toLowerCase();
    return filter
      ? items.filter((i) => i.name.toLowerCase().includes(lowerFilter))
      : items;
  }, [filter, items.length]);

  useAsyncEffect(async () => {
    if (filter) {
      await loadAll();
    }
  }, [filter]);

  return {
    filter,
    titleText,
    isLoading,
    filteredList,
    addButtonText: addText,
    setFilter,
    onSelectGroup: onSelect,
    onAddGroupClick: onAdd,
    loadMoreGroups: loadMore,
  };
};

export type LazyLoadListComponentProps = ReturnType<
  typeof useLazyLoadListLogic
>;
export const MOCK_LAZY_LOAD_LIST_PROPS: LazyLoadListComponentProps = {
  filter: '',
  filteredList: [],
  isLoading: false,
  setFilter: MockHook.mockFunction,
  addButtonText: 'Add Group',
  loadMoreGroups: MockHook.mockFunction,
  onAddGroupClick: MockHook.mockFunction,
  onSelectGroup: MockHook.mockFunction,
  titleText: 'Your Groups',
};
export default MockHook.useMockHook(
  useLazyLoadListLogic,
  MOCK_LAZY_LOAD_LIST_PROPS
);
